DfpAds = window.DfpAds ?= {}

DfpAds.init = ({dfpHeader}, done) ->
  return done() unless dfpHeader

  $(window).load ->
    Groupon.DFPAds ||= {}
    
    Groupon.DFPAds.showAds = ->
      $('.dfp-footer, .dfp-side-rail').map(->
        @id
      ).each (i, id) ->
        googletag.cmd.push ->
          googletag.display id

    done()


module.exports = DfpAds
